import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryMediaPlay extends EventRegistryCategory {
    label = 'Play';
    constructor(parent) {
        super(parent);
        super.init();
    }
    mediasequenceended = () => new EventRegistryItem({ handlerName: 'onMediaSequenceEnded' });
    videoended = () => new EventRegistryItem({ handlerName: 'onVideoEnded' });
}
